import { createIdentifyOperation, type IdentifyOperation } from "./carrotquest"
import { getRequestUrl } from "./request"

export type DemoFieldValues = {
  name?: string
  phone?: string
  site?: string
  role?: string
  traffic?: string
}

type DemoInputRef = {
  readonly current: HTMLInputElement | null
}

type BuildDemoIdentifyPayloadParams = DemoFieldValues & {
  requestType: string
  carrotId?: string | null
  yandexClientId?: string | null
  requestUrl?: string
  beforeRequestTypeOperations?: IdentifyOperation[]
}

type BuildDemoTrackPayloadParams = DemoFieldValues & {
  title: string
  yandexClientId?: string | null
  requestUrl?: string
  beforeTypeFields?: Record<string, unknown>
}

/** Свойства Carrot quest для форм, где клиент выбирает способ связи. */
export const CONTACT_CHANNEL_PROPERTY = "Способ связи"
export const TELEGRAM_PROPERTY = "Telegram"

export const getDemoFormRefValues = (name: DemoInputRef, phone: DemoInputRef, site: DemoInputRef): DemoFieldValues => ({
  name: name.current?.value,
  phone: phone.current?.value,
  site: site.current?.value,
})

export const getDemoSubmitEvent = ({ isAudit, submitEvent }: { isAudit?: boolean; submitEvent?: string }) =>
  isAudit ? "Заполнил форму на аудит" : submitEvent?.trim() || "Заполнил форму на демо"

export const getDemoBlogTag = (pathname = location.pathname) => {
  const urlPath = pathname.replace(/$/, "")

  return urlPath === "/blog/ai-email-personalization/" ? "Хочет AI-персонализацию в email" : undefined
}

export const buildDemoIdentifyPayload = ({
  name,
  phone,
  role,
  site,
  traffic,
  requestType,
  carrotId,
  yandexClientId,
  requestUrl = getRequestUrl(),
  beforeRequestTypeOperations = [],
}: BuildDemoIdentifyPayloadParams): IdentifyOperation[] => [
  createIdentifyOperation("$name", name),
  // Телефона может не быть: на части лендингов вместо него оставляют ник
  // в Telegram, и пустой $phone затёр бы уже известный номер в Carrot quest.
  ...(phone ? [createIdentifyOperation("$phone", phone)] : []),
  ...(role !== undefined ? [createIdentifyOperation("Роль", role)] : []),
  createIdentifyOperation("Адрес сайта", site),
  ...(traffic !== undefined ? [createIdentifyOperation("Объем трафика", traffic)] : []),
  ...beforeRequestTypeOperations,
  createIdentifyOperation("Тип заявки", requestType),
  createIdentifyOperation("Источник заявки", requestUrl),
  createIdentifyOperation("carrot_id", carrotId),
  createIdentifyOperation("yandexClientId", yandexClientId),
]

export const buildDemoTrackPayload = ({
  title,
  name,
  phone,
  site,
  role,
  traffic,
  yandexClientId,
  requestUrl = getRequestUrl(),
  beforeTypeFields = {},
}: BuildDemoTrackPayloadParams): Record<string, any> => ({
  Заголовок: title,
  Имя: name,
  ...(phone ? { Телефон: phone } : {}),
  Сайт: site,
  ...(role !== undefined ? { Роль: role } : {}),
  ...(traffic !== undefined ? { "Объем трафика": traffic } : {}),
  ...beforeTypeFields,
  type: "form",
  url: requestUrl,
  yandexClientId,
})

export const buildDemoWorkingTimeIdentifyPayload = (isDayoff: boolean): IdentifyOperation[] => [
  createIdentifyOperation("Время заявки на демо", isDayoff ? "Нерабочее" : "Рабочее"),
]

export const trackDemoSubmitGoals = ({ isAudit = false }: { isAudit?: boolean } = {}) => {
  if (typeof ym === "function") {
    const ymEventRequest = isAudit ? "audit_request" : "demo_request"
    const ymEventFinish = isAudit ? "audit_finish" : "demo_finish"

    ym(25430054, "reachGoal", ymEventRequest)
    ym(25430054, "reachGoal", ymEventFinish)
    // Единственное место, откуда шлётся submit_all: в pixels() он дублировался,
    // а на Dashly-сборке pixels() не выполняется вовсе.
    ym(25430054, "reachGoal", "submit_all")
  }
}
